module.exports = __webpack_public_path__ + "static/media/win-normal-boss.fb087839.mp3";